// extracted by mini-css-extract-plugin
module.exports = {"card":"_1YCkU146QuoKePpadSztgb","right-label":"_2bKvZG8-3aYXAdPjzQWYy2","rightLabel":"_2bKvZG8-3aYXAdPjzQWYy2"};